<template>
    <section class="light-content light-content-secondary">
        <div class="container">
            <div class="row">

                <div class="col-md-12 col-sm-12">
                    <post 
                        type="view" 
                        :post="post"
                        :isLinkable="false"
                        :isHtmlContent="true"
                        style="border: 1px solid #f2f2f2" />
                </div> <!-- /.col-md-12 -->

            </div>
        </div> <!-- /.container -->
    </section> <!-- /.services -->
</template>

<script>
// @ is an alias to /src
import Post from '@/components/Post.vue'
import posts from '@/posts.js'

export default {
    name: 'post-view',
    components: {
        Post
    },
    data() {
        return {
            post: null
        }
    },
    methods: {
        postFind(id) {
            return posts.find(post => {return post.id == id})
        }
    },
    mounted() {
        this.post = this.postFind(this.$route.params.id)
    },
    watch: {
        $route(to, from) {
            this.post = this.postFind(to.params.id);
        }
    }
}
</script>
